import './button.scss';

const Button = ({text, onClick, loading}) => {
    let buttonClass = 'button';

    if (loading) {
        buttonClass += ' loading';
    }

    return (
        <button onClick={onClick} className={buttonClass}>
            {loading ? "Загрузка..." : text}
        </button>
    );
}

export default Button;